module.exports = __webpack_public_path__ + "img/客户整合@2x.e22a74e5.png";